import { axiosInstance } from "./api";

export default {
  getData: () => axiosInstance.get("basePermissions")
};
